module.exports = __webpack_public_path__ + "static/media/yygcard.4fdc6b26.jpg";